export const configuration = {
  dates: {
    1: { value: '1', label: 'Today' },
    7: { value: '7', label: 'Last 7 days' },
    14: { value: '14', label: 'Last 14 days' },
    ALL: { value: 'ALL', label: 'Show all' },
  },
};
